<template>
  <cc-container>
    <area-skeleton v-show="showSkeleton"/>
    <cc-header-nav
      title="秒杀专区"
      v-show="!showSkeleton"
    >
    <template slot="right">
      <div  class="ellipsis">
        <van-icon
          class="ellipsis-icon"
          name="ellipsis"
          @click.stop="isShowSmallNav = !isShowSmallNav"
        />
      </div>
    </template>
    </cc-header-nav>
    <cc-main  v-show="!showSkeleton">
      <not-goods  v-if="list.length === 0 && m_loading === false"></not-goods>
      <template v-else>
        <div class="select-time-wrap" ref="selectTimeWrap">
          <ul
            class="select-time-tab"
            ref="timeDom"
            :style="{width: dateList.length >5 ? dateList.length * 75 + 'px':'100%'}"
          >
            <li
              class="select-time-item"
              :class="{active:item.flag }"
              v-for="(item,index) in dateList"
              :key="index"
            >
              <div @click="toggle(index)" style="display: inline-block">
                <div class="select-time-item-time">{{item.time}}</div>
                <div
                  class="select-time-item-txt"
                >{{item.startTime > item.nowTime ? "即将开抢":(item.nowTime > item.endTime ?"已结束": "秒杀中")}}</div>
              </div>
            </li>
          </ul>
        </div>
        <cc-pull-refresh v-model="isLoading" @refresh="onRefresh" :disabled="disabled">
          <div class="seckill-content" ref="seckillScrool">
            <div class="notice-time">
              <div>{{!isStart ? '活动即将开始，敬请期待' : '抢购中，先到先得哦'}}</div>
              <div class="time" v-if="selectTime.nowTime < selectTime.endTime">
                {{isStart ? "距结束：" : "距开始："}}
                <span>{{selectTime.countDown.h}}</span>：
                <span>{{selectTime.countDown.m}}</span>：
                <span>{{selectTime.countDown.s}}</span>
              </div>
              <div class="time" v-else>已经结束</div>
            </div>
            <van-list
              :class="['goods',!showLoading?'loading-icon':'']"
              v-model="m_loading"
              :finished="m_finished"
              :finished-text="m_finishedText"
              @load="mHandlePullUpLoadMore"
              :immediate-check="m_immediateCheck"
            >
              <goods-item
                v-for="item in list"
                :key="item.id"
                :item="item"
                :selectTime="selectTime"
                :stockTag="getShowStock (item)"
                @click.native="toDetail(item)"
              >
                <template slot="btn">
                  <goods-btn
                    :btn-type="getGoodsType(item)"
                    @openCart="openCart(item)"
                  />
                </template>
              </goods-item>
            </van-list>
          </div>
        </cc-pull-refresh>
      </template>
    </cc-main>
    <cc-small-nav v-model="isShowSmallNav"/>
    <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        getContainer="body"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
    <!-- 缺货弹窗start-->
      <cc-nogoods-remind
        :isShowPopup="shownogoods"
        :cartItem="cartItem"
        getContainer="body"
        :height="426"
        @close="shownogoods=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    <!-- 缺货弹窗end -->
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { List, Icon, Toast } from 'vant'
import BScroll from 'better-scroll'
import ListMixin from '@/mixins/list'
import { getSeckillList } from '~fetch/home/seckill'
import { ResultCode } from '~const/ResultCode'
import { getNowTime } from '~fetch/common'
import GoodsItem from '../components/item-component'
import NotGoods from '../components/not-goods'
import CartStepMixin from '@/mixins/cartStep'
import CommandMixin from '@/mixins/command'
import GoodsBtn from '../components/btn'
import AreaSkeleton from '../components/area-skeleton'
Vue.use(Icon).use(List)
let toast = null
export default {
  name: 'seckill',
  mixins: [ListMixin, CartStepMixin, CommandMixin],
  components: { AreaSkeleton, NotGoods, GoodsItem, GoodsBtn },
  data () {
    return {
      disabled: false,
      isLoading: false,
      isShowSmallNav: false,
      showLoading: true,
      dateList: [], // 时间列表
      list: [], // 所有商品
      selectTime: {
        startTime: '',
        endTime: ''
      },
      showSkeleton: true,
      tabIndex: 0, // 高亮的时间区域索引
      seckillType: 1
    }
  },
  activated () {
    this.loadData()
  },
  computed: {
    isStart () {
      let time = this.selectTime
      return time.startTime < time.nowTime
    },
    getShowStock () {
      return function (item) {
        if (this.getLoginStatus.data.member_id) {
          // 登录
          if (this.selectTime.startTime <= this.selectTime.nowTime) {
            // 秒杀中
            if (item.stock <= 0 || +item.min_stock === 0) {
              return 3
            } else if (item.goodsstock <= 0) {
              return 2
            } else {
              return 1
            }
          } else if (this.selectTime.nowTime > this.selectTime.endTime) {
            // 秒杀活动结束
            return 3
          } else {
            return 1
          }
        } else {
          return 1
        }
      }
    },
    getGoodsType () {
      return function (item) {
        if (this.getLoginStatus.data.member_id) { // 登录
          if (item.is_view === 1) { // 区域经销
            return 1
          }
          if (this.selectTime.startTime <= this.selectTime.nowTime) { // 秒杀中
            // 秒杀库存 商品库存 限购量都大于0才能购买
            if (item.stock > 0 && item.goodsstock > 0 && item.min_stock > 0) {
              return 2
            } else if (item.stock <= 0 || +item.min_stock === 0) { // 秒杀库存 或者限购量 没了就不能买了 已抢光
              return 3
            } else if (item.goodsstock <= 0) { // 商品库存没了 需要预定
              return 4
            }
          } else if (this.selectTime.startTime > this.selectTime.nowTime) { // 秒杀未开始
            return 5
          } else if (this.selectTime.nowTime > this.selectTime.endTime) { // 秒杀活动结束
            return 3
          }
          return 2
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    toDetail (item) {
      this.$router.push({
        path: '/goods-details',
        query: {
          goods_id: item.goods_id,
          type: item.for_type
        }
      })
    },
    openCart (item) {
      console.log(item)
      this.cartBtnAlter(item, this.cartIconColorno0(item) ? 1 : 0)
    },
    initBScroll () {
      this.$nextTick().then(() => {
        this.scroll = new BScroll(this.$refs.selectTimeWrap, {
          scrollX: true,
          click: true,
          bounce: false
        })
        this.$refs.seckillScrool.onscroll = e => {
          if (e.target.scrollTop > 0) {
            this.disabled = true
          } else {
            this.disabled = false
          }
        }
      })
    },
    async search () {
      this.mReset()
      await this.loadData(true)
      this.isLoading = false
    },
    /**
     * @description 下拉刷新
     */
    async onRefresh () {
      let nowTime = await getNowTime()
      this.selectTime.nowTime = +nowTime
      this.showLoading = false
      this.search()
    },
    async toggle (index) {
      let nowTime = await getNowTime()
      this.showLoading = false
      this.tabIndex = index
      this.seckillType = 2
      this.dateList.forEach(item => {
        item.flag = false
      })
      this.dateList[index].flag = true
      this.selectTime = this.dateList[index]
      this.selectTime.nowTime = +nowTime
      toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner'
      })
      this.search()
    },
    toNewest (isSelect) {
      if (this.dateList.length > 5 && isSelect > 4) {
        this.$nextTick(() => {
          let oLiWidth = this.$refs.timeDom.getElementsByTagName('li')[0]
            .offsetWidth
          this.scroll.refresh()
          if (this.dateList.length - isSelect >= 4) {
            this.scroll.scrollTo(
              -(oLiWidth * isSelect),
              0,
              700,
              'bounce'
            )
          } else {
            this.scroll.scrollTo(
              -(oLiWidth * this.dateList.length - oLiWidth * 5),
              0,
              700,
              'bounce'
            )
          }
        })
      }
    },
    /**
     * @description 加载秒杀商品
     */
    async loadData (reset) {
      this.mRequest()
      const params = {
        page: this.m_page.curr,
        limit: this.m_page.limit,
        seckill_type: this.seckillType,
        start_time: this.selectTime.startTime || '',
        end_time: this.selectTime.endTime || ''
      }
      let { data, status } = await getSeckillList(params)
      if (toast) {
        toast.clear()
      }
      if (this.showSkeleton) {
        this.showSkeleton = false
      }
      if (status === ResultCode.SUCCESS) {
        this.showLoading = true
        if (data.length === 0) {
          this.mEnd()
          return
        }
        // 第一次返回时间区间
        if (data.heading_arr) {
          this.initBScroll()
          this.dateList = data.heading_arr.map((item, index) => {
            return {
              time: item.format_time,
              flag: +data.is_select === index,
              nowTime: +item.now_time,
              startTime: +item.start_time,
              endTime: +item.end_time,
              countDown: {}
            }
          })
          // 每场活动执行定时器
          this.dateList.forEach(item => {
            this.countDown(item)
          })
          // 如果最新的活动超过第五个，就滚动到最新活动
          this.toNewest(data.is_select)
          this.tabIndex = +data.is_select
          this.selectTime = this.dateList[this.tabIndex]
          this.seckillType = 2
        }
        if (data.seckill_goods_arr.length === 0) {
          this.mEnd('--我也是有底线的--')
        } else {
          if (reset) {
            this.list = data.seckill_goods_arr
          } else {
            this.list.push(...data.seckill_goods_arr)
          }
          this.addGoodField(this.list)
          if (data.seckill_goods_arr.length < 10) {
            this.mEnd('--我也是有底线的--')
          }
        }
        this.mSuccess()
      } else {
        this.mEnd()
      }
    },
    /**
     * @description 倒计时
     */
    countDown (item) {
      let totalSeconds
      // 相差的总秒数
      if (item.startTime >= item.nowTime) {
        totalSeconds = parseInt(item.startTime - item.nowTime)
      } else if (item.startTime < item.nowTime && item.nowTime < item.endTime) {
        totalSeconds = parseInt(item.endTime - item.nowTime)
      }
      if (totalSeconds >= 0) {
        let h = Math.floor(totalSeconds / 60 / 60)
        let m = Math.floor((totalSeconds / 60) % 60)
        let s = Math.floor(totalSeconds % 60)
        item.countDown.h = h >= 10 ? h : '0' + h
        item.countDown.m = m >= 10 ? m : '0' + m
        item.countDown.s = s >= 10 ? s : '0' + s
      } else {
        item.countDown = 0
      }
      // 延迟一秒执行自己
      this.timer = setTimeout(() => {
        item.nowTime += 1
        this.countDown(item)
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
  .select-time-wrap {
    width: 100vw;
    height: 60px;
    overflow: hidden;
    .select-time-tab{
      height: 100%;
      display: flex;
      .select-time-item{
        height: 100%;
        flex: 1;
        text-align: center;
        &-time{
          font-size: 19px;
          margin-top: 13px;
          color: #555555;
        }
        &-txt{
           display: inline-block;
           padding: 2px 5px;
           border-radius: 8px;
           color: #777777;
        }
      }
      .active{
        .select-time-item-time{
          color: var(--APP_theme_color);
        }
        .select-time-item-txt{
          background: var(--APP_theme_color);
          color: #ffffff;
        }
      }
    }

  }
  .notice-time{
    width: 355px;
    margin: 5px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    color: #ED6410;
    padding: 0 10px;
    height: 40px;
    background: url("~@/assets/img/home/seckill-bg.png") no-repeat;
    background-size: 100%;
    .time{
      span{
        font-size: 9px;
        width: 15px;
        height: 15px;
        border-radius:4px;
        position: relative;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        &:before{
          content: " ";
          position: absolute;
          display: inline-block;
          top: 0;
          left: 0;
          width: 200%;
          border-radius: 10px;
          height: 200%;
          border: 1px solid rgba(239,181,144,1);
          transform-origin: 0 0;
          transform: scale(0.5);
        }
      }
    }
  }
  .seckill-content{
    height: calc(100vh - 106px);
    overflow: scroll;
  }
  .goods{
    width:100%;
    box-sizing: border-box;
    padding: 0 10px;
    /deep/{
      .van-list__loading {
        display: none;
      }
    }

  }
  .ellipsis{
    width: 50%;
    height: 100%;
    @include center();
    transform: translateX(-5px);
    &-icon{
      transform: rotate(90deg);
    }
  }
</style>
